module.exports = __webpack_public_path__ + "img/provinceApplyen.271801fe.jpg";